console.log("[js-searchanise-prices] loaded!")

const RES_ELM_SELECTOR = 'li[id*="snize-ac-product"][data-original-product-id], li[id*="snize-product"][data-original-product-id]';

function applyDiscountOnResElm(elm) {
    const $elm = $(elm)
    const productId = $elm.data('original-product-id');
    const discountedPrice = window.discountedPrices?.[productId];

    if (!discountedPrice) {
        return;
    }

    const $priceList = $elm.find('.snize-price-list');
    const $originalPriceEl = $priceList.find('.snize-price');

    if ($priceList.find('.snize-discounted-price').length > 0) {
        return;
    }

    const originalPriceText = $originalPriceEl.text().trim();
    const originalPrice = parseFloat(originalPriceText.replace(/[^0-9.]/g, ''));

    if (!originalPrice || discountedPrice >= originalPrice) {
        return;
    }

    const formattedDiscounted = `$${discountedPrice.toFixed(2)}`;
    const formattedOriginal = `$${originalPrice.toFixed(2)}`;

    $priceList.html(`
        <span class="snize-price snize-price-with-discount money">${formattedDiscounted}</span>
        <span class="snize-discounted-price money">${formattedOriginal}</span>
    `);
}


const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
            if (!(node instanceof HTMLElement)) continue;

            if (node.matches?.(RES_ELM_SELECTOR)) {
                applyDiscountOnResElm(node);
            }

            const matches = node.querySelectorAll?.(RES_ELM_SELECTOR);
            matches?.forEach(applyDiscountOnResElm);
        }
    }
});

observer.observe(document.body, {
    childList: true, subtree: true,
});
